import React from "react";
import { Helmet } from "react-helmet";
import { Button } from "antd";
import { FlightDirectionBlock } from "../HotelProfile/Components/MarketingOfferPreviewModal";
import { MARKETING_OFFER_DISCLAIMER } from "../../../utils/dynamicPackage/generateMarketingOffer";
import { resolveBrandedCompanyLogoUrl } from "../../../utils/hotelsRiverBrandLogo";

export default function PublicOfferHeroTemplate({
  vm,
  title,
  legalNote,
  onInterest,
  interestBusy,
  interestDone,
  branding = null,
}) {
  const h = vm?.header || {};
  const f = vm?.flights || {};
  const hot = vm?.hotel || {};
  const r = vm?.room || {};
  const p = vm?.price || {};
  const heroBg = vm?.heroImageUrl || null;
  const logoUrl = resolveBrandedCompanyLogoUrl(branding?.logoUrl || null);

  return (
    <div className="public-offer-hero-page" dir="rtl">
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={h?.datesLine || "הצעת חבילת נופש"} />
      </Helmet>

      {heroBg ? (
        <div className="public-offer-hero-page__bg" aria-hidden="true">
          <img src={heroBg} alt="" className="public-offer-hero-page__bg-img" loading="eager" />
        </div>
      ) : null}
      <div className="public-offer-hero-page__overlay" aria-hidden="true" />

      <article className="public-offer-hero-card">
        <header className="public-offer-hero-card__header">
          <div className="public-offer-hero-card__branding">
            <img src={logoUrl} alt="HotelsRiver" className="public-offer-hero-card__logo" />
            <span className="public-offer-hero-card__brand-name">
              {branding?.agencyName || "HotelsRiver"}
            </span>
          </div>
          <p className="public-offer-hero-card__kicker">
            {h?.packageTaglineHe || "הצעת חופשה מותאמת אישית"}
          </p>
          <h1 className="public-offer-hero-card__title">
            {h?.headlineHe || "הצעת נופש מוכנה עבורך"}
          </h1>
          <p className="public-offer-hero-card__dates">{h?.datesLine || "לפי תאריכי החיפוש"}</p>
        </header>

        <section className="public-offer-hero-card__section">
          <h3>טיסות</h3>
          <p className="moffer-preview__stay-note">{f?.stayDatesNoteHe}</p>
          <FlightDirectionBlock row={f?.outbound} />
          {f?.showInboundSection ? (
            <FlightDirectionBlock row={f?.inbound} />
          ) : (
            <p className="moffer-flight-row__muted moffer-flight-row__muted--block">
              חבילת כיוון אחד — ללא טיסת חזור
            </p>
          )}
          {f?.baggageLine ? (
            <p className="moffer-preview__baggage">כבודה: {f.baggageLine}</p>
          ) : null}
        </section>

        <section className="public-offer-hero-card__section public-offer-hero-card__section--hotel">
          <h3>מלון</h3>
          <p className="public-offer-hero-card__hotel-name">
            {hot?.name || "מלון נבחר"} {hot?.starsCount > 0 ? hot?.starsEmoji : ""}
          </p>
          <p>{hot?.locationLine || "יעד לבחירה"}</p>
          <p>בסיס אירוח: {hot?.boardLabel || "—"}</p>
          {Array.isArray(hot?.facilities) && hot.facilities.length > 0 ? (
            <div className="public-offer-hero-card__tags">
              {hot.facilities.slice(0, 4).map((x) => (
                <span key={x}>{x}</span>
              ))}
            </div>
          ) : null}
        </section>

        <section className="public-offer-hero-card__section">
          <h3>חדר נבחר</h3>
          <p className="public-offer-hero-card__room-name">{r?.name || "חדר נבחר"}</p>
          <p>מתאים ל: {r?.occupancyLabel || "—"}</p>
        </section>

        <section className="public-offer-hero-card__section public-offer-hero-card__section--price">
          <div className="public-offer-hero-card__price-label">{p?.titleHe || "מחיר כולל"}</div>
          <div className="public-offer-hero-card__price-value">{p?.amountDisplay || "—"}</div>
          <div className="public-offer-hero-card__price-sub">
            {p?.subTitleHe || "כולל עמלות והיטלים"}
          </div>
          <p className="public-offer-hero-card__disclaimer">{MARKETING_OFFER_DISCLAIMER}</p>
        </section>

        <p className="public-offer-hero-card__cta-copy">{vm?.footerCtaHe}</p>
        <p className="public-offer-hero-card__legal">{legalNote}</p>

        <Button
          type="primary"
          size="large"
          block
          className="public-offer-hero-card__cta-btn"
          loading={interestBusy}
          disabled={interestDone}
          onClick={onInterest}
        >
          {interestDone ? "תודה, פנייתך נרשמה" : "אני מעוניין / אני מעוניינת"}
        </Button>
      </article>
    </div>
  );
}
